/** 公告地址 */
export const BULLETIN_URL = 'https://shopee.cn/edu/article/26794';
export const LOCAL_BULLETIN_URL =
  'https://open.shopee.com/announcements/1324?category=3&is_top=false';
